import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MagicLinkStatus = ({ email, onResend, onBack }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-center w-16 h-16 mx-auto bg-success/10 rounded-full">
        <Icon name="Mail" size={32} color="var(--color-success)" strokeWidth={2} />
      </div>

      <div className="text-center space-y-2">
        <h3 className="text-xl font-semibold text-foreground">Check Your Email</h3>
        <p className="text-sm text-muted-foreground">
          We've sent a secure magic link to
        </p>
        <p className="text-sm font-medium text-foreground">{email}</p>
      </div>

      <div className="bg-muted/50 rounded-lg p-4 space-y-3">
        <div className="flex items-start space-x-3">
          <Icon name="Clock" size={20} color="var(--color-primary)" strokeWidth={2} className="mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">Estimated Delivery</p>
            <p className="text-xs text-muted-foreground">Usually arrives within 1-2 minutes</p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} color="var(--color-primary)" strokeWidth={2} className="mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">Link Expiration</p>
            <p className="text-xs text-muted-foreground">Valid for 15 minutes for security</p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="AlertCircle" size={20} color="var(--color-warning)" strokeWidth={2} className="mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground">Security Notice</p>
            <p className="text-xs text-muted-foreground">Do not share this link with anyone</p>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-3">Didn't receive the email?</p>
          <Button
            variant="outline"
            fullWidth
            iconName="RefreshCw"
            iconPosition="left"
            onClick={onResend}
          >
            Resend Magic Link
          </Button>
        </div>

        <Button
          variant="ghost"
          fullWidth
          iconName="ArrowLeft"
          iconPosition="left"
          onClick={onBack}
        >
          Try Different Email
        </Button>
      </div>

      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="HelpCircle" size={20} color="var(--color-primary)" strokeWidth={2} className="mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-foreground mb-2">Troubleshooting Tips</p>
            <ul className="text-xs text-muted-foreground space-y-1">
              <li>• Check your spam or junk folder</li>
              <li>• Verify the email address is correct</li>
              <li>• Ensure your inbox isn't full</li>
              <li>• Contact IT support if issues persist</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagicLinkStatus;